<ion-content class="ion-padding">
  <div class="edit-option-modal">
    <h1>Edit Option</h1>
    <ng-container [formGroup]="form">
      <div class="edit-option-modal__form">
        <div>
          <ion-label><strong>Name</strong> (required)</ion-label>
          <ion-input formControlName="name" maxlength="50"></ion-input>
        </div>
        <div>
          <ion-label><strong>Price</strong> (optional)</ion-label>
          <ion-input type="number" formControlName="price"></ion-input>
        </div>
      </div>
      <div class="edit-option-modal__actions">
        <ion-button color="clear" (click)="cancel()">Cancel</ion-button>
        <ion-button [disabled]="!form.valid || !form.dirty" color="dark" (click)="submit()">Edit Option</ion-button>
      </div>
    </ng-container>
  </div>
</ion-content>